import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function FinalCta() {
  const revealRef = useScrollReveal();
  return <section className="relative bg-brand-dark bg-grain py-[80px] md:py-[140px] px-[5%] overflow-hidden" data-id="element-61">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,_rgba(201,169,110,0.1)_0%,_transparent_60%)] pointer-events-none z-0" data-id="element-62" />

      <div ref={revealRef} className="max-w-7xl mx-auto relative z-10 text-center reveal" data-id="element-63">
        <h2 className="font-display italic font-light text-[clamp(42px,6vw,64px)] text-brand-cream max-w-[800px] mx-auto leading-[1.15] mb-10" data-id="element-64">
          "No busques la luz.
          <br data-id="element-65" />
          Sé la luz que colapsa la oscuridad
          <br data-id="element-66" />
          en nuevas galaxias de posibilidad."
        </h2>

        <div className="w-[80px] h-[1px] bg-brand-gold mx-auto mb-8" data-id="element-67" />

        <p className="font-body font-light text-[18px] text-brand-cream/60 mb-12" data-id="element-68">
          Tu nueva identidad ya existe en el campo.
          <br data-id="element-69" />
          Solo falta que la elijas.
        </p>

        <a href="https://learniacademy.com/cart/53230890647917:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block bg-brand-gold text-brand-dark font-body text-[16px] font-medium py-[20px] px-[48px] rounded-[50px] transition-all duration-300 hover:bg-brand-goldBright hover:-translate-y-[2px] hover:shadow-[0_12px_30px_rgba(201,169,110,0.35)] w-full md:w-auto" data-id="element-70">
          SÍ, QUIERO RENACER — $13.97 &rarr;
        </a>

        <div className="flex flex-wrap justify-center gap-6 mt-10" data-id="element-71">
          {['Descarga inmediata', '3 bonos gratis', 'Garantía 7 días', 'Pago seguro'].map((trust, i) => <div key={i} className="font-body text-[13px] text-brand-cream/40" data-id="element-72">
              ✦ {trust}
            </div>)}
        </div>
      </div>
    </section>;
}